import { useEffect } from "react";
import app from "nystem";

const ReferenceTaglink = ({ model, value, view, path }) => {
  useEffect(() => {
    if (!value) return;

    const search = async (type, filter = {}, count = 400000) => {
      const { data } = await app.database[type].search({
        filter,
        sortby: ["name", "title"],
        reverse: [true, true],
        role: "super",
        count,
      });
      return data;
    };

    const item = view.getValue(path);
    const sync = async () => {
      let data = await search(item.type, { tag: value });
      data = (data || []).map(({ _id }) => _id);
      const oldVal = item[item.type] || [];
      const old = oldVal.filter((_id) => data.includes(_id));
      const add = data.filter((_id) => !old.includes(_id));
      const newVal = [...old, ...add];

      if (oldVal.slice().sort().join() === newVal.slice().sort().join()) return;

      view.setValue({ path: `${path}.${item.type}`, value: newVal });
    };
    sync();
    app.database[item.type].on("change", sync);

    return () => {
      app.database[item.type].off("change", sync);
    };
  }, [model, path, value, view]);

  return null;
};

export default ReferenceTaglink;
